import { FlagModule } from '@/modules/featureFlags/domain/models/FlagModule'

import { useFeatureFlagsQuery } from './queries/useFeatureFlagsQuery'

export function useFeatureFlagManager() {
  const featureFlagsQuery = useFeatureFlagsQuery()

  const checkFlag = (flag: FlagModule): boolean =>
    !!featureFlagsQuery.data?.find(({ module }) => flag === module)?.enabled

  const checkFlagAndReturn = <T>(flag: FlagModule, toReturn: T): T[] =>
    checkFlag(flag) ? [toReturn] : []

  return {
    checkFlag,
    checkFlagAndReturn
  }
}
